import GetStarted from "./components/GetStarted";
import VendorInformation from "./components/VendorInformation";

export const steps = [
  { Component: GetStarted, progressLabel: "Get Started", key: "get-started" },
  { Component: VendorInformation, progressLabel: "Info", key: "info" },
];
